export default __webpack_public_path__ + "static/media/credit-onb-back-2.60eef462.png";